import {Injectable} from '@angular/core';
import {FormSubmissionResult} from '../entity/form-submittion-result';
import {FormDefinition, FormIdentifier} from '../entity/form-definition';
import {NewSubmission} from '../entity/new-form-submission';
import {environment} from '../../environments/environment';
import {ApplicationConfiguration} from '../../environments/application-configurations';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private readonly env: ApplicationConfiguration = environment;
  private readonly formToVersionMap: Record<string, FormIdentifier> = {
    'flood': {formId: 'floodcountry-01', version: 'v1.0.0'},
    'earthquake': {formId: 'earthquake-country-01', version: 'v1.0.0'},
    'earthquake-thailand-chubb-2026': {formId: 'earthquake-thailand-chubb-2026', version: 'v1.0.0'},
  };

  getFormByName(formName: string): Promise<FormDefinition> {
    if (!this.formToVersionMap.hasOwnProperty(formName)) throw new Error(
      `No version found for form ${formName}.`
    )
    const formIdentifier = this.formToVersionMap[formName];
    return this.getForm(formIdentifier.formId, formIdentifier.version);
  }

  async getForm(formId: string, version: string): Promise<FormDefinition> {
    const apiUrl: string = `${this.env.fnolPublishedFormsBackend.baseUrl}/${this.env.fnolPublishedFormsBackend.getPublishedFormDefinitionPath}`
      .replace('{formId}', formId)
      .replace('{formVersion}', version);
    console.log(`[FormService] Calling GET ${apiUrl}`);
    let form: FormDefinition;
    let response = await fetch(apiUrl);
    if (response.ok) {
      form = await response.json();
    } else {
      throw new Error(response.statusText);
    }
    return form as FormDefinition;
  }

  async submitForm(submission: NewSubmission): Promise<FormSubmissionResult> {
    const apiUrl: string = `${this.env.claimManagerBackend.baseUrl}/${this.env.claimManagerBackend.postSubmitFormPath}`
    console.log(`[FormService] Calling POST ${apiUrl}`);
    const r = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(submission)
    });
    return (await r.json()) as FormSubmissionResult;
  }

  async finalizeSubmission(submissionId: string): Promise<void> {
    const apiUrl = `${this.env.claimManagerBackend.baseUrl}/${this.env.claimManagerBackend.postFinalizeSubmitFormPath}`.replace("{submissionId}", submissionId.trim());
    console.log(`[FormService] Calling POST ${apiUrl}`);
    const response = await fetch(apiUrl, {method: 'POST'});
    if (!response.ok) {
      const body = await response.text();
      throw new Error(body || response.statusText);
    }
  }


}
